import { useFormikContext } from 'formik';
import type { EmailEntryWriteType } from '@econtractor/types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import spinnerTitle from 'components/others/spinnerTitle';
import { useEmailsDirectory } from './context/EmailsDirProvider';

const EmailEntryForm = () => {
    const { t } = useTranslation('EmailsDir');
    const { values, errors, submitCount, handleChange, handleBlur, handleSubmit, isSubmitting } = useFormikContext<EmailEntryWriteType>();
    const { setEditing, busy } = useEmailsDirectory();
    return (
        <Form noValidate onSubmit={handleSubmit} className="border rounded p-3 mb-3">
            <Row>
                <Form.Group as={Col} md={6} controlId="emails-dir-name" className="mb-3">
                    <Form.Label>{t('name')}</Form.Label>
                    <Form.Control name="name" value={values.name} onChange={handleChange} onBlur={handleBlur} maxLength={250} disabled={busy} isInvalid={Boolean(submitCount > 0 && errors.name)} autoFocus />
                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={6} controlId="emails-dir-email" className="mb-3">
                    <Form.Label>{t('email')}</Form.Label>
                    <Form.Control name="email" type="email" value={values.email} onChange={handleChange} onBlur={handleBlur} maxLength={250} disabled={busy} isInvalid={Boolean(submitCount > 0 && errors.email)} />
                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Form.Check id="emails-dir-public" name="isPublic" label={t('public')} checked={values.isPublic} onChange={handleChange} disabled={busy} className="mb-3" />
            <div className="d-flex justify-content-end gap-2">
                <Button type="button" size="sm" variant="secondary" disabled={busy} onClick={() => setEditing(null)}>{t('cancel')}</Button>
                <Button type="submit" size="sm" variant="info" disabled={busy || isSubmitting}>
                    {spinnerTitle(t('save'), busy || isSubmitting, t('saving'))}
                </Button>
            </div>
        </Form>
    );
};

export default EmailEntryForm;
